import { AnimatedSprite } from "appworks/graphics/animation/animated-sprite";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { TGRMatrixComponent } from "components/tgr-matrix";
import { gameLayers } from "game-layers";
import { AnticipationResult } from "slotworks/model/gameplay/records/results/anticipation-result";
import { TGRSoundEvent } from "tgr-sound-event-enum";

export class DMFMatrixComponent extends TGRMatrixComponent {

    protected anticipationReel(reelIndex: number): void {
        const anticipationResult: AnticipationResult = gameState.getCurrentGame().getCurrentRecord().getFirstResultOfType(AnticipationResult);
        if (anticipationResult.anticipateSymbols[reelIndex][0]) {
            let symbol: string = anticipationResult.anticipateSymbols[reelIndex][0].replace(/^QH[j_].*/, "QH");

            if (reelIndex === 4) {
                symbol = "QH";
            }

            gameLayers.Anticipation.setScene(symbol).then(() => {
                gameLayers.Anticipation.enableBoundsMask(true);
                for (let i: number = 0; i <= reelIndex; i++) {
                    const animation: AnimatedSprite = gameLayers.Anticipation.getAnimatedSprite(`anticipation_${i}`);
                    if (animation) {
                        if (symbol === "QH") {
                            animation.tint = 0x5ce600;
                        }
                        if (i === reelIndex) {
                            if (reelIndex === 4) {
                                symbol = "QH";
                            }
                            Services.sound.customEvent(TGRSoundEvent[`anticipation_${symbol}`]);
                            animation.visible = true;
                            animation.playRange(0, 11, true);
                        } else {
                            Services.sound.customEvent(TGRSoundEvent.anticipation_end);
                            animation.stop();
                            animation.visible = false;
                        }
                    }
                }
            });
        }
    }
}
